import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthContext } from '@/modules/auth/ui/AuthProvider';
import { queryKeys } from './queryKeys';

export function useCrmSalespersonAccess() {
  const { authFetch } = useAuthContext();

  return useQuery({
    queryKey: queryKeys.crm.salespersonAccess,
    queryFn: async () => {
      const response = await authFetch('/api/crm/salesperson-access');
      if (!response.ok) throw new Error('Failed to load salesperson access');
      return response.json();
    },
  });
}

export function useGrantSalespersonAccess() {
  const { authFetch } = useAuthContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ email, sourceValue }) => {
      const response = await authFetch('/api/crm/salesperson-access', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, sourceValue }),
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to grant access');
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.crm.salespersonAccess });
    },
  });
}

export function useRevokeSalespersonAccess() {
  const { authFetch } = useAuthContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (accessId) => {
      const response = await authFetch(`/api/crm/salesperson-access?id=${accessId}`, {
        method: 'DELETE',
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to revoke access');
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.crm.salespersonAccess });
    },
  });
}
